/* ============================================================
   WISHLIST — v100
   ------------------------------------------------------------
   Before this file the heart buttons only toggled a CSS class.
   Nothing was saved, the header heart did nothing, and there was
   no wishlist page — so a shopper who "saved" six pieces had
   six pieces saved nowhere.

   HOW IT WORKS
   Handles are kept in localStorage under toi:wishlist. The page
   at /pages/wishlist reads that list and fetches each product
   from Shopify's own /products/<handle>.js endpoint, so the card
   always shows live price and availability rather than whatever
   was true on the day it was saved.

   WHY HANDLES AND NOT IDS
   A handle is what the .js endpoint takes, and it survives a
   product being re-saved in admin. If a product is deleted the
   fetch 404s and that entry is dropped quietly on next visit.

   NO ACCOUNT NEEDED
   This is per-browser, like a cart before checkout. It is not
   synced across devices; making it so would mean a customer
   metafield and a logged-in account, which is a bigger change.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'toi:wishlist';

  /* ---------- store ---------- */
  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];              /* private mode, or someone hand-edited the value */
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) { /* quota or private mode — the session still works in memory */ }
    broadcast(list);
  }

  function has(handle) { return read().indexOf(handle) !== -1; }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.unshift(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1;
  }

  function broadcast(list) {
    document.dispatchEvent(new CustomEvent('toi:wishlist:change', { detail: { items: list } }));
  }

  /* ---------- header count ---------- */
  function paintCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  /* ---------- button state ---------- */
  function paintButtons(scope) {
    (scope || document).querySelectorAll('.wishlist-btn[data-wishlist-handle]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-wishlist-handle'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  /* One delegated listener, so cards added later by Load more work too. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.wishlist-btn') : null;
    if (!btn) return;
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;        /* the header heart is a link, not a toggle */
    e.preventDefault();
    e.stopPropagation();        /* the whole card is a link — do not follow it */
    var added = toggle(handle);
    btn.classList.toggle('is-active', added);
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
    paintButtons();
    if (window.__toiToast) window.__toiToast(added ? 'Saved to your wishlist' : 'Removed from your wishlist');
  });

  document.addEventListener('toi:wishlist:change', function () { paintCount(); });

  /* ---------- wishlist page ---------- */
  function money(cents) {
    var fmt = window.__moneyFormat || 'Rs. {{amount}}';
    var v = (cents / 100);
    var s = v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]*>/g, '');
  }

  function card(p) {
    var img = p.featured_image
      ? '<img src="' + p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') + '" alt="" loading="lazy">'
      : '';
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    return '' +
      '<div class="product-card" data-wl-card="' + p.handle + '">' +
        '<a class="product-link" href="' + p.url + '" aria-label="' + p.title.replace(/"/g, '&quot;') + '"></a>' +
        '<div class="product-media media-a">' +
          '<div class="card-slides">' + img + '</div>' +
          (p.available ? '' : '<span class="product-badge">Sold out</span>') +
          '<button class="product-wishlist wishlist-btn is-active" type="button" aria-pressed="true"' +
            ' data-wishlist-handle="' + p.handle + '" aria-label="Remove from wishlist">' +
            '<svg class="icon" style="width:16px;height:16px"><use href="#i-heart" xlink:href="#i-heart"/></svg>' +
          '</button>' +
        '</div>' +
        (p.type ? '<div class="product-tag">' + p.type + '</div>' : '') +
        '<div class="product-name">' + p.title + '</div>' +
        '<div class="product-meta"><span class="product-price' + (sale ? ' price--sale' : '') + '">' +
          (sale ? '<span class="price-was was">' + money(p.compare_at_price) + '</span>' : '') +
          money(p.price) +
        '</span></div>' +
      '</div>';
  }

  function renderPage(root) {
    var grid = root.querySelector('[data-wl-grid]');
    var empty = root.querySelector('[data-wl-empty]');
    var busy = root.querySelector('[data-wl-loading]');
    var list = read();

    function show(state) {
      if (busy) busy.hidden = state !== 'loading';
      if (empty) empty.hidden = state !== 'empty';
      if (grid) grid.hidden = state !== 'ready';
    }

    if (!list.length) { show('empty'); return; }
    show('loading');

    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (results) {
      var alive = [];
      var html = '';
      results.forEach(function (p, i) {
        if (!p) return;                       /* deleted or unpublished — drop it */
        alive.push(list[i]);
        html += card(p);
      });
      if (alive.length !== list.length) write(alive);
      if (!html) { show('empty'); return; }
      grid.innerHTML = html;
      show('ready');
      paintButtons(grid);
    });
  }

  /* A card removed on the wishlist page should leave straight away. */
  document.addEventListener('toi:wishlist:change', function (e) {
    var page = document.querySelector('[data-wl-page]');
    if (!page) return;
    var kept = e.detail.items;
    page.querySelectorAll('[data-wl-card]').forEach(function (el) {
      if (kept.indexOf(el.getAttribute('data-wl-card')) === -1) el.remove();
    });
    if (!kept.length) {
      var grid = page.querySelector('[data-wl-grid]');
      var empty = page.querySelector('[data-wl-empty]');
      if (grid) grid.hidden = true;
      if (empty) empty.hidden = false;
    }
  });

  function init() {
    paintCount();
    paintButtons();
    var page = document.querySelector('[data-wl-page]');
    if (page) renderPage(page);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { paintButtons(e.target); });

  window.__toiWishlist = { read: read, has: has, toggle: toggle };
})();
